var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSealCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.106 18.894c-.863-.862-.291-2.674-.73-3.736C3.921 14.063 2.25 13.172 2.25 12s1.67-2.063 2.126-3.158c.439-1.06-.133-2.874.73-3.736.862-.863 2.675-.291 3.736-.73C9.942 3.921 10.828 2.25 12 2.25s2.063 1.67 3.158 2.126c1.062.439 2.874-.133 3.736.73.863.862.291 2.674.73 3.736.455 1.1 2.126 1.986 2.126 3.158s-1.67 2.063-2.126 3.158c-.439 1.062.133 2.874-.73 3.736-.862.863-2.674.291-3.736.73-1.095.455-1.986 2.126-3.158 2.126s-2.063-1.67-3.158-2.126c-1.06-.439-2.874.133-3.736-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.75 10.5 15l5.25-5.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealCheck);
export default __webpack_public_path__ + "static/media/SealCheck.a8fa503185734aa5e780db5e8d3994e3.svg";
export { ForwardRef as ReactComponent };